import instance from "../http";
import { getHeader } from "../../utils/utils";
import { userDocument } from "../../constants/path";

export async function updateDocumentData(_documentId, _documentData) {
  const headers = getHeader();
  const response = await instance.patch(
    userDocument.UPDATE_DOCUMENT + _documentId + "/update",
    _documentData,
    headers
  );
  return response;
}

export async function syncData(document_uuid, project_uuid) {
  const headers = getHeader();
  const response = await instance.post(
    userDocument.SYNC_DOCUMENT.replace(":uuid", document_uuid),
    { project_uuid },
    headers
  );
  return response;
}

export async function unSyncData(document_uuid, project_uuid) {
  const headers = getHeader();
  const response = await instance.post(
    userDocument.UNSYNC_DOCUMENT.replace(":uuid", document_uuid),
    { project_uuid },
    headers
  );
  return response;
}

export async function resyncApi(_resyncData, project_uuid) {
  const headers = getHeader();
  const response = await instance.post(
    `${userDocument.RESYNC_DOCUMENT}`,
    { documents: _resyncData, project_uuid: project_uuid },
    headers
  );
  return response;
}

export async function getDocumentApi({ id, docType }) {
  const headers = getHeader();
  const response = await instance.get(
    userDocument.GET_DOCUMENT + id + `/show?type=${docType}`,
    headers
  );
  return response;
}

export async function documentLableAddApi(labelData) {
  const headers = getHeader();
  const response = await instance.post(
    userDocument.DOCUMENT_LABEL,
    labelData,
    headers
  );
  return response;
}

export async function labelListingAPi(values) {
  const headers = getHeader();
  const response = await instance.get(
    userDocument.LABEL_LISTING + `?project_uuid=${values}`,
    headers
  );
  return response;
}

export async function singleLableApi(values) {
  const headers = getHeader();
  const response = await instance.get(
    userDocument.SINGLE_LABEL + values,
    headers
  );
  return response;
}

export async function updateLabelApi(values, bodyData) {
  const headers = getHeader();
  const response = await instance.patch(
    userDocument.UPDATE_LABEL + values,
    bodyData,
    headers
  );
  return response;
}

export async function deleteLabelApi(values) {
  const headers = getHeader();
  const response = await instance.delete(
    userDocument.DELETE_LABEL + values,
    headers
  );
  return response;
}

export async function labelDocumentApi(values) {
  const headers = getHeader();
  const response = await instance.post(
    userDocument.APPLY_LABEL,
    values,
    headers
  );
  return response;
}

export async function removeTagsApi(docUUID, labelUUID) {
  const headers = getHeader();
  const response = await instance.delete(
    userDocument.REMOVE_TAGS + `${docUUID}/` + labelUUID,
    headers
  );
  return response;
}
